export default __webpack_public_path__ + "static/media/research-arrow-mobile.d1525ab1.svg";